var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutfitActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,480H72a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8h32l47.92-32H296.07L344,96h32a8,8,0,0,1,8,8V472A8,8,0,0,1,376,480Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344 96 296.07 64 224 168 151.92 64 104 96 192 230.33 192 480 256 480 256 230.33 344 96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904,336H848c0-95.28-69.41-174.34-160.43-189.4A8.24,8.24,0,0,0,688,144c0-8.84-14.33-16-32-16s-32,7.16-32,16a8.24,8.24,0,0,0,.43,2.6C533.41,161.66,464,240.72,464,336v56a8,8,0,0,0,8,8H904a8,8,0,0,0,8-8V344A8,8,0,0,0,904,336Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.89,237.47c-7.81,29.13-12,63.17-12,98.53H527.69A128.11,128.11,0,0,1,573.89,237.47Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688,336H624c0-34,7.24-66.87,15.53-92.45,6.45-19.89,13.43-30,17.41-34.18,4,4.14,11,14.29,17.41,34.18C682.64,269.13,688,302,688,336Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.31,336H752c0-34.53-4-67.78-11.46-96.45A128,128,0,0,1,784.31,336Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.85,608V960l148-249.31a8,8,0,0,0-2.61-10.85Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.85,960H551.18a8,8,0,0,1-7.85-6.43l-36.48-182.4V488a8,8,0,0,1,8-8h288a8,8,0,0,1,8,8Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.85,576v64h112a64.07,64.07,0,0,1-64,64h-48v64h48a128.14,128.14,0,0,0,128-128h128V576Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,832A120.13,120.13,0,0,0,352,712v-.44l-64-40.41L264,656l-20.74-27.65a8,8,0,0,0-8.5-2.92l-164.86,45a8,8,0,0,0-5.9,7.72V888a8,8,0,0,0,8,8H464a8,8,0,0,0,8-8V832Zm-184,0H128V720l72-16,88,56.44Zm64-56a56.06,56.06,0,0,1,56,56H352Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288 832 128 832 128 720 200 704 288 760.44 288 832",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,776a56.06,56.06,0,0,1,56,56H352Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfitActive);
export default __webpack_public_path__ + "static/media/outfit_active.3c9bc28fa9bac02d6d9c0d6c2032a61f.svg";
export { ForwardRef as ReactComponent };